import React from "react";
import { useGetUserAuthQuery } from "../../redux/authService";

function Authorization({
  children,
  authenticateOnly
}) {
  const authorized = useGetUserAuthQuery(authenticateOnly);

  if(authorized.isSuccess) {
    return <>{children}</>;
  }

  return <></>;
  
}

export default Authorization;
